import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setAddedDevices, setRemovedDevices } from '#action/project/devices-popup';
import { getSymmetricDifference, getDeviceDiff } from '#component/device/devices-popup/helper';

export const useFloatDevicesSyncProject = (
  formDataObj,
  openedFromForm,
  addMode,
  renderRef,
  emptyForm,
  refetchDataRef
) => {
  const { projectId } = formDataObj;

  const dispatch = useDispatch();
  const formInitialValues = formDataObj?.initialFormDevices;
  const formDevices = formDataObj?.formDevices || [];

  useEffect(() => {
    if (!openedFromForm || !projectId || emptyForm) {
      refetchDataRef.current = true;
      return;
    }

    if (!formInitialValues || !formDevices.length) {
      return;
    }

    const symmetricDiff = getSymmetricDifference(formDevices, formInitialValues);
    const isDevicesWasReplaced = formDevices?.length === formInitialValues?.length &&
      symmetricDiff.length;

    if (isDevicesWasReplaced && !addMode) {
      const devicesDiff = getDeviceDiff(formDevices, formInitialValues);
      const diffWithSymmetric = getDeviceDiff(symmetricDiff, devicesDiff);

      if (devicesDiff.length) {
        dispatch(setAddedDevices(devicesDiff));
      }

      if (diffWithSymmetric.length) {
        dispatch(setRemovedDevices(diffWithSymmetric));
      }
    } else {
      const addedDevices = getDeviceDiff(formDevices, formInitialValues);
      const removedDevices = getDeviceDiff(formInitialValues, formDevices);

      if (addedDevices.length) {
        dispatch(setAddedDevices(addedDevices));
      }

      if (removedDevices.length) {
        dispatch(setRemovedDevices(removedDevices));
      }
    }

    refetchDataRef.current = true;
  }, [
    addMode,
    dispatch,
    projectId,
    formDevices,
    openedFromForm,
    formInitialValues,
    renderRef,
    emptyForm,
    refetchDataRef
  ]);
};
